export const Columns = {
    SOLD_DATE: 'SOLD_DATE',
    ATTENDEE: 'ATTENDEE',
    COMPANY: 'COMPANY',
    BARCODE: 'BARCODE',
    RATE: 'RATE',
    SEAT: 'SEAT',
    SESSION: 'SESSION',
    SCANNED: 'SCANNED',
    STATUS: 'STATUS',
    MODERATION_STATUS: 'MODERATION_STATUS',
    MAILS: 'MAILS',
    ACTIONS: 'ACTIONS'
};
